import { z } from 'zod';

export const SourceSchema = z.object({
  source: z.string().min(1, 'Source is required'),
  sourceType: z.string().min(1, 'Source Type is required'),
  usePreset: z.string().optional(),
});

export type SourceSchemaFormValues = z.infer<typeof SourceSchema>;
